<template>
  <div class="login_header">
    <div class="login_image">
      <img class="" src="../../assets/img/logo_white.png" />
      <span class="login_title size-18 white" v-if="$route.name == 'login'">{{
        $t("login_pageText.LOGIN_TITLE")
      }}</span>
    </div>
    <!-- <div class="login_welcome" v-if="$route.name != 'login'">
      <span class="size-15">{{ $t("common_pageText.MSG_ACCEXIST") }}</span>
      <router-link
        class="login_link size-15"
        :to="langcode ? '/login?langcode=' + langcode : '/login'"
        >{{ $t("common_pageText.MSG_LOGIN") }}</router-link
      >
    </div> -->
  </div>
</template>
<script>
export default {
  data() {
    return {
      pageText: {
        loginTitle: this.$t("login_pageText.LOGIN_TITLE")
      }
    };
  },
  watch: {
    "$i18n.locale"(curVal, oldVal) {
      this.pageText.loginTitle = this.$t("login_pageText.LOGIN_TITLE");
    }
  }
};
</script>

<style scoped>
.login_header {
  width: 100%;
  height: 55px;
  /* height: 173px; */
  display: flex;
  align-items: center;
  background-color: #000;
  overflow: hidden;
  justify-content: space-between;
  border-bottom: 2px solid #bf0510;
  box-sizing: border-box;
}
.login_image {
  display: flex;
  align-items: center;
  /* margin-left: 280px; */
  margin-left: 100px;
  /* margin-top: 10px; */
}
.login_title {
  margin-left: 30px;
  /* margin-top: 6px; */
  vertical-align: middle;
}
.login_welcome {
  color: #999;
  margin-right: 300px;
}
</style>
